/* istanbul ignore file */
import _ from 'underscore';
import { useContext, useMemo } from 'react';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

export const useAdAssetsInstrument = () => {
  const instrumentation = useContext(InstrumentationContext);

  const logger = useMemo(() => {
    if (instrumentation && instrumentation.pmaxLiteAdAssets) {
      const scenario = instrumentation.pmaxLiteAdAssets.create();
      return scenario.adAssetsStep.create();
    }
    return {
      trace: _.noop,
      error: _.noop,
    };
  }, [instrumentation]);

  return logger;
};
